import { productTopReviewsTemplateURL } from '../../../configuration/Configuration.js';
import rejectNonOkResponse from '../rejectNonOkResponse.js';

export default async (params) => {
  const response = await rejectNonOkResponse(fetch(productTopReviewsTemplateURL(params)));
  return response.text();
};
